export const MANUAL_GOOGLE_FB = [
  {
    language: 'es',
    link: 'https://statics.myhotel.cl/foto-encuesta/Autenticaci%C3%B3n%20Facebook%20y%20Google%20my%20Business%20%282%29%20%281%29.pdf'
  },
  {
    language: 'en',
    link: 'https://statics.myhotel.cl/foto-encuesta/Facebook%20and%20Google%20my%20Business%20Authentication%20%282%29.pdf'
  },
  {
    language: 'pt',
    link: 'https://statics.myhotel.cl/foto-encuesta/Autentica%C3%A7%C3%A3o%20Facebook%20e%20Google%20MyBusiness%20%283%29.pdf'
  }
]
